import { Edit, SimpleForm, type EditProps } from "react-admin";

import MiqaatVenueFormFields from "./MiqaatVenueFormFields";
import { transformMiqaatVenuePayload } from "./transform-miqaat-venue-payload";

export default function MiqaatVenueEdit(props: EditProps) {
  return (
    <Edit {...props} transform={transformMiqaatVenuePayload}>
      <SimpleForm warnWhenUnsavedChanges sx={{ maxWidth: 720 }}>
        <MiqaatVenueFormFields />
      </SimpleForm>
    </Edit>
  );
}
